import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Catch-all for unmatched routes. Previously an unknown path rendered a blank
// page (QA #510/#513); now we always show content and offer a way back.
export default function NotFound() {
  const navigate = useNavigate();
  const authed = Boolean(sessionStorage.getItem("token"));
  return (
    <Box sx={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center", p: 3 }}>
      <Stack spacing={2} alignItems="center" textAlign="center">
        <Typography sx={{ fontSize: 72, fontWeight: 800, color: "primary.main", lineHeight: 1 }}>404</Typography>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>Page not found</Typography>
        <Typography sx={{ color: "text.secondary", maxWidth: 420 }}>
          The page you're looking for doesn't exist or may have moved.
        </Typography>
        <Button variant="contained" onClick={() => navigate(authed ? "/EmployeeDashboard" : "/login", { replace: true })}>
          {authed ? "Go to Dashboard" : "Go to Login"}
        </Button>
      </Stack>
    </Box>
  );
}
